import { TagGroup } from "@models/tagGroup.model";
import { proxy } from "valtio";
import { ContentCatalogFolder } from "@models/contentCatalogFolder.model";
import { Ad } from "@models/Ad.model";
import { type SearchTreeResult, EMPTY_SEARCH } from "./contentCatalogSearch";

export const contentCatalogStore = proxy<{
  // The org whose catalog is on screen. A listing also carries the sub-orgs' folders
  // (MPN-1921), so render sites compare against this to spot a borrowed one.
  organizationId: number | null;
  panelMode: "browse" | "filter";
  selectedId: string;
  pendingScrollFolderId: number | null;
  query: string;
  tagGroups: TagGroup[];
  collections: ContentCatalogFolder[];
  folders: ContentCatalogFolder[];
  selectedTagIds: number[];
  loading: boolean;
  filterResults: Ad[];
  filterLoading: boolean;
  selectedAdIds: number[];
  folderSearch: SearchTreeResult;
}>({
  organizationId: null,
  panelMode: "browse",
  selectedId: "__all__",
  pendingScrollFolderId: null,
  query: "",
  tagGroups: [],
  selectedTagIds: [],
  loading: false,
  collections: [],
  folders: [],
  filterResults: [],
  filterLoading: false,
  selectedAdIds: [],
  folderSearch: EMPTY_SEARCH,
});
